export default "/images/d91a4d6f6406f270e7fb9589b2db3f28.avif";